module.exports = __webpack_public_path__ + "static/img/SketchPngf2d4b396d8ab60c05abc69ea6630b7a2bd9ebfdd96555f712518fd064f4aeb79.50921a31.png";